import { useCallback, useEffect, useState } from "react";
import { settings } from "app";
import { Card, CardContent, Chip } from "@mui/material";
import { Datagrid, FunctionField, TextField } from "react-admin";
import { useParams } from "react-router-dom";
import { studentRequests } from "api/studentApi";
import { SectionTitle } from "features/SectionTitle";
import dataProvider from "server/dataProvider";

const StudentRecordContinuingDisciplines = () => {
  const { id } = useParams();
  const [disciplines, setDisciplines] = useState(null);

  const fetchContinuingDisciplines = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentRecordContinuingDisciplines(id),
        null,
        "GET",
      );
      setDisciplines(
        (data?.disciplines ?? []).map(discipline => ({
          ...discipline,
          id: discipline.disciplineId,
        })),
      );
    } catch (err) {
      console.error("Error fetching continuing disciplines", err);
      setDisciplines([]);
    }
  }, [id]);

  useEffect(() => {
    if (!id) return;
    fetchContinuingDisciplines();
  }, [id, fetchContinuingDisciplines]);

  if (!disciplines?.length) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="Продължаващи дисциплини"
        textAlign="center"
      />
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Datagrid
            resource="continuing-disciplines"
            data={disciplines}
            rowClick={false}
            bulkActionButtons={false}
            sx={[settings.style.detailsDatagrid, { "& .column-disciplineName": { width: "60%" } }]}
          >
            <TextField
              source="disciplineName"
              label="Дисциплини"
            />
            <FunctionField
              label="Семестри"
              render={rec => rec.semesters?.join(", ") || "-"}
            />
            <FunctionField
              label="Практически изпит"
              render={rec =>
                rec.hasPracticalExam ? (
                  <Chip
                    label="Да"
                    color="success"
                    size="small"
                  />
                ) : (
                  <Chip
                    label="Не"
                    variant="outlined"
                    size="small"
                  />
                )
              }
            />
          </Datagrid>
        </CardContent>
      </Card>
    </>
  );
};

export default StudentRecordContinuingDisciplines;
